import {Routes} from "@angular/router";
import {AutomationRoutes} from "./x-models/x-enums/automation-routes";
import {AutomationManagerComponent} from "./automation-manager/automation-manager.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";
import {StockMarketComponent} from "./_views/stock-market/stock-market.component";
import {WorkflowsComponent} from "./workflows/workflows.component";

export const AUTOMATION_ROUTES: Routes = [
  {
    path: AutomationRoutes.AutomationManager, component: AutomationManagerComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_AutomationManagerComponent().default},
    title: "Automations-Manager"
  },
  {
    path: AutomationRoutes.ViewStockMarket, component: StockMarketComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_AutomationViewComponent().default},
    title: "Aktienmarkt"
  },
  {
    path: AutomationRoutes.Workflows, component: WorkflowsComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_AutomationWorkflowsComponent().default},
    title: "Workflows"
  }
]
